import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchTransactionList } from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import { SS_ROLE } from "../../../../utility/constants/secureStorageManager";
import {
  CLIENT,
  CREDIT_CONFIRMATION,
  STATUS_CODE_200,
  TRANSACTION_CREDIT,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBIT,
  TRANSACTION_DEBITED,
  TRANSACTION_FAILED,
  TRANSACTION_PENDING,
  TRANSACTION_REFUND,
  TRANSACTION_REJECTED
} from "../../../../utility/constants/valueConstants";
import { formatBalance } from "../../../../utility/moneyFormatter";
import {
  PayoutTransactionHeaders,
  PrefundTransactionHeaders,
  TransactionHeaders
} from "../../../../utility/TableHeaders";
import CustomModal from "../../../components/main_comps/custom_modal";
import { CustomViewModal } from "../../../components/main_comps/custom_modal/CustomViewModal";
import CustomTable from "../../../components/main_comps/custom_table";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import { useSnackbar } from "notistack";
import { fullScreenLoadingSlice } from "../../../../data/redux/slice/loaderSlice";

const PrefundTransaction = ({ selectedService }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const transaction = useSelector(
    (state) => state.listingSlice.prefundTransactionList
  );
  const clientSecret = useSelector((state) => state.listingSlice.clientDetails);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [currentPage, setCurrentPage] = useState(0);
  const [viewMoreModal, setViewMoreModal] = useState(false);
  const [rejectAcceptModal, setRejectAcceptModal] = useState(false);
  const [viewMoreData, setViewMoreData] = useState({});
  const [dataForModal, setDataForModal] = useState({});
  const [clientDetails, setClientDetials] = useState({});
  const [action, setAction] = useState("");
  const filters = useSelector((state) => state.globalFiltersSlice);
  const getClientProgram = () => {
    let payout = clientSecret.filter((obj) => obj.serviceType === "payout");
    if (payout.length > 0) {
      setClientDetials(payout[0]);
    }
  };

  const role = secureStorage.getItem(SS_ROLE);

  const onClickAction = (action, data) => {
    dispatch(fullScreenLoadingSlice(true));
    ApiRequestPost.approveRejectPrefundAction({
      action,
      transferUniqueNo: data?.transferUniqueNo,
      clientId: data?.client_id
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response?.message, {
            variant: "success"
          });
          dispatch(
            fetchTransactionList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: 0,
              size: 10,
              resellerId: filters?.resellerId?.value,
              clientId: filters?.clientId?.value,
              status: filters?.status ? filters?.status?.value : "",
              serviceType: "prefund",
              rootReferenceId: "",
              custRefNo: filters?.custRefNo ?? "",
              transactionId: filters?.transactionId ?? "",
              serviceProviderName:
                role === CLIENT
                  ? clientDetails?.serviceProviderName
                  : selectedService
            })
          );
        } else {
          enqueueSnackbar(response?.message, {
            variant: "error"
          });
        }
      })
      .catch((error) => {
        enqueueSnackbar(error?.message, {
          variant: "error"
        });
      })
      .finally(() => {
        dispatch(fullScreenLoadingSlice(false));
      });
  };

  useEffect(() => {
    let data1 = {
      "Reseller Name": role === CLIENT ? "N/A" : viewMoreData?.reseller_name
    };
    let data = {
      "Date & Time:": moment(viewMoreData?.created_at).format(
        "DD/MM/YYYY HH:mm A"
      ),
      "Client Name": viewMoreData?.client_name,
      "Prefund Amount":
        "Rs " + formatBalance(Number(viewMoreData?.actual_amount)),
      Commission:
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_CREDIT
          ? "Rs " + formatBalance(Number(viewMoreData?.commissionAmount))
          : "Rs 0",
      "Commission Gst":
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_CREDIT
          ? "Rs " + formatBalance(Number(viewMoreData?.commissionGst))
          : "Rs 0",

      "Final Amount":
        viewMoreData["status"] === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_CREDIT
          ? "Rs " + formatBalance(Number(viewMoreData?.final_amount))
          : "Rs " + formatBalance(Number(viewMoreData?.actual_amount)),

      Status:
        viewMoreData?.status === TRANSACTION_CREDITED ||
        viewMoreData["status"] === TRANSACTION_CREDIT ||
        viewMoreData["status"] === CREDIT_CONFIRMATION
          ? "Success"
          : viewMoreData?.status === TRANSACTION_FAILED ||
            viewMoreData["status"] === TRANSACTION_DEBIT
          ? "Failed"
          : viewMoreData?.status === TRANSACTION_PENDING
          ? "Initiated"
          : viewMoreData?.status === TRANSACTION_REJECTED
          ? "Rejected"
          : "",

      "Bennificary Account Number": viewMoreData?.prefundAccountNumber ?? "N/A",
      "Bennificary IFSC":
        viewMoreData?.beneAccountIfsc ?? viewMoreData?.prefundIfsc ?? "N/A",
      "Transfer Type": viewMoreData?.transferType ?? "N/A",
      "Transfer  Unique number": viewMoreData?.utr ? viewMoreData?.utr : "N/A",
      "Transfer currency": viewMoreData?.transferCcy ?? "INR",
      "Remitter Name ": viewMoreData?.client_name ?? "N/A",
      "Remitter Account number": viewMoreData?.remitterAccount ?? "N/A",
      "Remitter IFSC":
        viewMoreData?.rmtrAccountIfsc ?? viewMoreData?.remitterIfsc ?? "N/A",
      "Remitter account Type": viewMoreData?.rmtAcountType ?? "N/A",
      "Remitter Address": viewMoreData?.rmtrAddress ?? "N/A",
      "Modified Date":
        moment(viewMoreData?.modified_at).format("DD/MM/YYYY HH:mm A") ??
        moment(viewMoreData?.paymentTime).format("DD/MM/YYYY HH:mm A")
    };

    if (role === CLIENT) {
      setDataForModal(data);
    } else {
      setDataForModal({ ...data, ...data1 });
    }
  }, [viewMoreData]);

  const setHeaders = (data, role, acl) => {
    let arr = [];

    data &&
      data?.map((val, i) => {
        if (val?.roles || val?.acl) {
          if (val?.roles?.includes(role) || acl?.includes(val?.acl))
            arr.push({
              title: val?.title,
              key: val?.key
            });
        } else {
          arr.push({
            title: val?.title,
            key: val?.key
          });
        }
      });
    return arr;
  };

  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 15);
  const defaultDateRange = `${("0" + startDate.getDate()).slice(-2)}/${(
    "0" +
    (startDate.getMonth() + 1)
  ).slice(-2)}/${startDate.getFullYear()}-${("0" + endDate.getDate()).slice(
    -2
  )}/${("0" + (endDate.getMonth() + 1)).slice(-2)}/${endDate.getFullYear()}`;

  useEffect(() => {
    dispatch(
      fetchTransactionList({
        dateRange:
          filters?.fromDate && filters?.toDate
            ? moment(filters?.fromDate).format("DD/MM/YYYY") +
              "-" +
              moment(filters?.toDate).format("DD/MM/YYYY")
            : defaultDateRange,
        page: 0,
        size: 10,
        resellerId: filters?.resellerId?.value,
        clientId: filters?.clientId?.value,
        status: filters?.status ? filters?.status?.value : "",
        serviceType: "prefund",
        rootReferenceId: "",
        custRefNo: filters?.custRefNo ?? "",
        transactionId: filters?.transactionId ?? "",
        serviceProviderName: "Cashfree"
      })
    );
  }, []);

  useEffect(() => {
    if (selectedService || clientDetails?.serviceProviderName) {
      dispatch(
        fetchTransactionList({
          dateRange:
            filters?.fromDate && filters?.toDate
              ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                "-" +
                moment(filters?.toDate).format("DD/MM/YYYY")
              : defaultDateRange,
          page: 0,
          size: 10,
          resellerId: filters?.resellerId?.value,
          clientId: filters?.clientId?.value,
          status: filters?.status ? filters?.status?.value : "",
          serviceType: "prefund",
          rootReferenceId: "",
          custRefNo: filters?.custRefNo ?? "",
          transactionId: filters?.transactionId ?? "",
          serviceProviderName:
            role === CLIENT
              ? clientDetails?.serviceProviderName
              : selectedService
        })
      );
    }
  }, [clientDetails, selectedService]);
  useEffect(() => {
    if (role === CLIENT) {
      getClientProgram();
    }
  }, []);

  return (
    <div style={{ padding: "0px 10px", overflow: "hidden" }}>
      <CustomTable
        data={transaction?.transactions}
        currentPage={transaction?.currentPageNo - 1}
        headers={setHeaders(PrefundTransactionHeaders, role, aclData)}
        totalElements={transaction?.totalRecords}
        totalPages={transaction?.totalPages}
        handlePaginate={(page) => {
          setCurrentPage(page);
          dispatch(
            fetchTransactionList({
              dateRange:
                filters?.fromDate && filters?.toDate
                  ? moment(filters?.fromDate).format("DD/MM/YYYY") +
                    "-" +
                    moment(filters?.toDate).format("DD/MM/YYYY")
                  : "",
              page: page + 1,
              size: 10,
              resellerId: filters?.resellerId?.value,
              clientId: filters?.clientId?.value,
              status: filters?.status ? filters?.status.value : "",
              serviceType: "prefund",
              custRefNo: filters?.custRefNo ?? "",
              transactionId: filters?.transactionId ?? "",
              serviceProviderName:
                role === CLIENT
                  ? clientDetails?.serviceProviderName
                  : selectedService
            })
          );
        }}
        onViewMore={(row) => {
          setViewMoreModal(true);
          setViewMoreData(row);
        }}
        emptyDataMessage="No transaction found."
        onClickAccept={(row) => {
          // setAction("Approve");
          // setRejectAcceptModal(true);
          // setViewMoreData(row);
          onClickAction("Approve", row);
        }}
        onClickReject={(row) => {
          onClickAction("Reject", row);
          // setAction("Reject");
          // setRejectAcceptModal(true);
          // setViewMoreData(row);
        }}
      />
      {viewMoreModal && (
        <CustomModal
          open={viewMoreModal}
          onClose={() => {
            setViewMoreModal(false);
            // setDataForModal({});
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "100%",
            borderRadius: "20px 0px 0px 20px"
          }}
          viewMoreStyle={{
            justifyContent: "flex-end"
          }}
          isHeaderRequired={false}
        >
          <CustomViewModal
            data={dataForModal}
            closeModal={() => {
              setViewMoreModal(false);
              // setDataForModal({});
            }}
          />
        </CustomModal>
      )}

      {rejectAcceptModal && (
        <CustomModal
          open={rejectAcceptModal}
          onClose={() => {
            setRejectAcceptModal(false);
            // setDataForModal({});
          }}
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "100%",
            borderRadius: "20px 0px 0px 20px"
          }}
          viewMoreStyle={{
            justifyContent: "flex-end"
          }}
          isHeaderRequired={false}
        >
          {/* <CustomViewModal
            data={dataForModal}
            closeModal={() => {
              setViewMoreModal(false);
              // setDataForModal({});
            }}
          /> */}

          <div style={{}}></div>
        </CustomModal>
      )}
    </div>
  );
};

export default PrefundTransaction;
